export type PlaceComponents = {
	street1: string;
	street2?: string;
	city: string;
	state: string;
	zipCode?: string;
};

export function placeComponents(parts: Record<string, string>): PlaceComponents {
	const street2 = parts.subpremise?.trim();
	const zipCode = parts.zipCode?.trim();
	return {
		street1: `${parts.streetNumber ?? ""} ${parts.streetName ?? ""}`.trim(),
		...(street2 ? { street2 } : {}),
		city: parts.city?.trim() ?? "",
		state: parts.state?.trim() ?? "",
		...(zipCode ? { zipCode } : {})
	};
}
